document.addEventListener('click', function(e){
  if (e.target && e.target.classList.contains('gift-card-disclaimer-link')) {
    var modal = document.getElementById("gift-card-disclaimer-modal");
    var span = document.getElementsByClassName("close")[0];
    if (modal) {
      modal.style.display = "block";
    }
    if (span) {
      span.onclick = function () {
        modal.style.display = "none";
      };
    }
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  }
});
